import React, { useEffect, useState } from 'react';

import _ from 'lodash';

import Field from '../../Fields/Field';
import InputTextField from '../../Fields/InputTextField';
import InputDateField from '../../Fields/InputDateField';
import InputSelectField from '../../Fields/InputSelectField';
import NoticeBlock from '../../Common/NoticeBlock';
import MessageList from '../../Common/MessageList';
import useReport from '../../../Hooks/useReport';
import BalanceReport from '../../../Utils/balanceReport';
import BalanceSummaryReport from '../../../Utils/balanceSummaryReport';

import './BalancesReportForm.scss';
import ActionButton from '../../Common/ActionButton';
import featureFlags from '../../../featureFlags'

function BalancesReportForm({ facilityId }) {

  const [report, setReport] = useState(null);
  const [selectedReportType, setSelectedReportType] = useState(null);
  const [currentBalanceChecked, setCurrentBalanceChecked] = useState(true);
  const [currentBalanceDisabled, setCurrentBalanceDisabled] = useState(true);
  const [subscriptionStatusChecked, setSubscriptionStatusChecked] = useState(false);
  const [subscriptionStatusDisabled, setSubscriptionStatusDisabled] = useState(true)

  useEffect(() => {
    if (report !== null) {
      if (featureFlags.OBALANCE) {
        switch (report) {
          case "OB_SUMMARY_REPORT":
            downloadCSVReport(true);
            break;
          case "OB_REPORT_PDF":
            downloadPDFReport(true)
            break;
          case "OB_REPORT":
            downloadCSVReport(true);
            break;
          case "OB_SUMMARY_REPORT_PDF":
            downloadPDFReport(true)
            break;
          default:
            downloadReport()
        }
      } else {
        report ? downloadReport() : downloadSummaryReport()
      }
      setReport(null)
    }
  }, [report])

  useEffect(() => {
    if (selectedReportType === "OB_REPORT") {
      setCurrentBalanceChecked(true)
      setCurrentBalanceDisabled(true)
      setSubscriptionStatusChecked(false)
      setSubscriptionStatusDisabled(true)
    } else {
      setSubscriptionStatusDisabled(false)
      setCurrentBalanceDisabled(false)
    }
  }, [selectedReportType])

  const isBalanceReport = featureFlags.OBALANCE ? (report === "OB_REPORT" || report === "OB_REPORT_PDF") : report;

  const {
    filterValues,
    downloadReport,
    downloadSummaryReport,
    downloadCSVReport,
    downloadPDFReport,
    downloadPDFSummaryReport,
    inputOnChange,
    resetFilters,
    isDownloadingCSV,
    isDownloadingSummary,
    isDownloadingPDF,
    errors,
    setCurrentBalance,
    setSubscriptionStatus
  } = useReport(isBalanceReport ? BalanceReport : BalanceSummaryReport, facilityId);

  const reportTypeOptions = [
    { label: "Select", value: "" },
    { label: "Outstanding Balances Report", value: "OB_REPORT" },
    { label: "Outstanding Balances Summary Report", value: "OB_SUMMARY_REPORT" }
  ];

  function toggleCurrent(value) {
    if (selectedReportType === "OB_REPORT") {
      setCurrentBalanceDisabled(true);
      inputOnChange('currentBalances', !value);
      setCurrentBalanceChecked(true);
    } else {
      setCurrentBalanceDisabled(false);
      setCurrentBalanceChecked(!value);
      inputOnChange('currentBalances', !value);
    }
    return !value;
  }

  function toggleSubscriptionStatus(value) {
    if (selectedReportType === "OB_REPORT") {
      setSubscriptionStatusChecked(false)
      setSubscriptionStatusDisabled(true)
      inputOnChange('subscriptionStatus', !value);
    } else {
      setSubscriptionStatusChecked(!value)
      setSubscriptionStatusDisabled(false)
      inputOnChange('subscriptionStatus', !value);
    }
    return !value;
  }

  return (
    <div className="parkchirp--balances-report--filter-form-container">
      <div className="parkchirp--balances-report--filter-form">
        <h2>Outstanding Balances Reports</h2>
        {!featureFlags.OBALANCE &&
          <div className="parkchirp--balances-report--filter-inputs">
            <div className="parkchirp--balances-report--filter-input-block">
              <Field label="Sub. ID"
                id="parkchirp--balances-report-filter--payor-id"
                layout="columns">
                <InputTextField inputId="parkchirp--balances-report-filter--payor-id"
                  value={filterValues.payorId}
                  onChange={inputOnChange('payorId')}
                  editMode={true}
                />
              </Field>
              <Field label="Sub. Name"
                id="parkchirp--transactions-report-filter--subscription_name"
                layout="columns">
                <InputTextField inputId="parkchirp--transactions-report-filter--subscription-name"
                  value={filterValues.subscriptionName}
                  onChange={inputOnChange('subscriptionName')}
                  editMode={true}
                />
              </Field>
            </div>
            <div className="parkchirp--balances-report--filter-input-block">
              <Field label="As of Date"
                id="parkchirp--balances-report-filter--as-of-date"
                layout="columns">
                <InputDateField inputId="parkchirp--balances-report-filter--as-of-date"
                  value={filterValues.date}
                  onChange={inputOnChange('date')}
                  editMode={true}
                  fixOffByOneIssue
                />
              </Field>
            </div>
          </div>
        }
        {featureFlags.OBALANCE &&
          <div className="parkchirp--balances-report--filter-inputs">
            <div className="parkchirp--balances-report--filter-input-block">
              <Field label="Report Type"
                id="parkchirp--balances-report-filter--report-type"
                layout="columns">
                <InputSelectField
                  inputId="parkchirp--balances-report--filter-form--report-type"
                  options={reportTypeOptions}
                  value={selectedReportType}
                  onChange={setSelectedReportType}
                  editMode={true}
                />
              </Field>
              <Field label="Sub. ID"
                id="parkchirp--balances-report-filter--payor-id"
                layout="columns">
                <InputTextField inputId="parkchirp--balances-report-filter--payor-id"
                  value={filterValues.payorId}
                  onChange={inputOnChange('payorId')}
                  editMode={true}
                />
              </Field>
              <div className='parkchirp--balances-report--filter--checkbox-row'>
                <Field
                  label="Subscription Status"
                  id="parkchirp--balances-report-filter--subscription-status"
                  layout="columns"
                  labelWidth={"lg"}
                >
                  <input
                    id="parkchirp--balances-report-filter--subscription-status"
                    checked={subscriptionStatusChecked}
                    onChange={() => setSubscriptionStatus(toggleSubscriptionStatus)}
                    disabled={subscriptionStatusDisabled}
                    type="checkbox"
                  />
                </Field>
                <Field
                  label="Current Balances"
                  id="parkchirp--balances-report-filter--current-balances"
                  layout="columns"
                >
                  <input
                    id="parkchirp--balances-report-filter--current-balances"
                    checked={currentBalanceChecked}
                    onChange={() => setCurrentBalance(toggleCurrent)}
                    disabled={currentBalanceDisabled}
                    type="checkbox"
                  />
                </Field>
                {selectedReportType === "OB_SUMMARY_REPORT" && (
                  <Field
                    label="Contact Information"
                    id="parkchirp--balances-report-filter--contact-information"
                    layout="columns"
                  >
                    <input
                      id="parkchirp--balances-report-filter--contact-information"
                      checked={filterValues.contactInfo}
                      onChange={() => {
                        inputOnChange('contactInfo', !filterValues.contactInfo);
                      }}
                      type="checkbox"
                    />
                  </Field>
                )}
              </div>
            </div>
            <div className="parkchirp--balances-report--filter-input-block">
              <Field label="Sub. Name"
                id="parkchirp--transactions-report-filter--subscription_name"
                layout="columns">
                <InputTextField inputId="parkchirp--transactions-report-filter--subscription-name"
                  value={filterValues.subscriptionName}
                  onChange={inputOnChange('subscriptionName')}
                  editMode={true}
                />
              </Field>
              <Field label="As of Date"
                id="parkchirp--balances-report-filter--as-of-date"
                layout="columns">
                <InputDateField inputId="parkchirp--balances-report-filter--as-of-date"
                  value={filterValues.date}
                  onChange={inputOnChange('date')}
                  editMode={true}
                  fixOffByOneIssue
                />
              </Field>
            </div>
            <div className="parkchirp--balances-report--filter-input-block">
              <Field label="Account ID"
                id="parkchirp--transactions-report-filter--subscription_name"
                layout="columns">
                <InputTextField inputId="parkchirp--transactions-report-filter--subscription-name"
                  value={filterValues.accountId}
                  onChange={inputOnChange('accountId')}
                  editMode={true}
                />
              </Field>
            </div>
          </div>
        }
        <div className="parkchirp--balances-report--filter-actions">
          {featureFlags.OBALANCE ?
            <>
              <ActionButton label="Download CSV"
                className={["button", "button-primary parkchirp--balances-report--filter-action download-csv"]}
                onClick={() => {
                  selectedReportType === "OB_REPORT" ? setReport("OB_REPORT") : setReport("OB_SUMMARY_REPORT")
                }}
                inProgressState={isDownloadingCSV || isDownloadingSummary}
                disabled={!selectedReportType}
              />
              <ActionButton label="Download PDF"
                classNames={["button", "button-primary parkchirp--balances-report--filter-action download-pdf"]}
                onClick={() => selectedReportType === "OB_REPORT" ? setReport("OB_REPORT_PDF") : setReport("OB_SUMMARY_REPORT_PDF")}
                inProgressState={isDownloadingPDF}
                disabled={!selectedReportType}
              />
            </>
            :
            <>
              <ActionButton label="Download Summary View"
                className={["button", "button-primary parkchirp--balances-report--filter-action"]}
                onClick={() => {
                  setReport(false);
                }}
                inProgressState={isDownloadingSummary}
              />
              <ActionButton label="Download Balances Report"
                classNames={["button", "button-primary parkchirp--balances-report--filter-action"]}
                onClick={() => {
                  setReport(true);
                }}
                inProgressState={isDownloadingCSV}
              />
            </>
          }
          <button type="button"
            className="button parkchirp--balances-report--filter-action"
            onClick={() => {
              setSelectedReportType(null)
              resetFilters()
            }}
          >
            Reset
          </button>
        </div>
        {!!errors.length &&
          <div className="parkchirp--invoice-reports--filter-errors">
            <NoticeBlock type="error" containerClasses={['parkchirp--sidebar-block']}>
              <MessageList
                heading={`An error occurred while attempting to generate the report.`}
                messages={errors}
              />
            </NoticeBlock>
          </div>
        }
      </div>
    </div >
  )
}

export default React.memo(BalancesReportForm);
